
import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { guestSchema } from 'src/validations/validation-schemas';

import {Label, Input} from 'reactstrap';
import { useFormik } from 'formik';

import { useQuery, useMutation } from 'react-query';
import useAxios from '../../sections/useAxios';

import { BsTrashFill } from 'react-icons/bs';

import ConfirmModal from './confirm-modal';


import 'react-toastify/dist/ReactToastify.css';



const GuestsDetailsModal = ({ isOpen, toggle, guestID, handleResponse }) => {

  let api = useAxios()

  const {
    data: guestObj,
    refetch
} = useQuery(`guestObj-${guestID}`, async () => api.get(`/guests/guest/${guestID}`), {enabled: !!guestID})

  const guestInfo = guestObj?.data
  const guest = guestInfo?.guest
  const arrivalFlight = guestInfo?.arrival_flight
  const departureFlight = guestInfo?.dep_flight

  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const onSubmit = (values) => {

    // let hasError = false; 

    // const arrivalTime = new Date(`2000-01-01T${values.arrivalTime}`);
    
    // if (values.arrivalBoardingTime){

    //   const arrivalBoardingTime = new Date(`2000-01-01T${values.arrivalBoardingTime}`);
      
    //   if (arrivalTime < arrivalBoardingTime){
    //     toast.error('Arrival time must be after boarding time')
    //     hasError = true;
    //   } 
    // }
    
    // const departureTime = new Date(`2000-01-01T${values.departureTime}`);
    // if (values.departureBoardingTime){
    //   const departureBoardingTime = new Date(`2000-01-01T${values.departureBoardingTime}`);
      
    //   if (departureTime < departureBoardingTime){
    //     toast.error('Departure time must be after boarding time')
    //     hasError = true;
    //   }
    // }

    // if (new Date(values.arrivalDate) > new Date(values.departureDate)) {
    //   toast.error('Departure Date must be after Arrival Date');
    //   hasError = true;
    // }

    // if (!hasError) {
      editGuestMutation.mutate(values);
    // }
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm, setFieldValue } = useFormik({
    initialValues: {
      title: guest?.title,
      firstName: guest?.first_name,
      lastName: guest?.last_name,
      phone: guest?.phone_number,
      room_number: guest?.room_number ?? '',
      passport: guest?.passport_number,
      authority: guest?.issuing_authority,
      
      arrivalFrom: arrivalFlight?.from_location,
      arrivalTo: arrivalFlight?.to_location,
      arrivalCarrier: arrivalFlight?.carrier,
      arrivalFlightNumber: arrivalFlight?.flight_number,
      arrivalDate: arrivalFlight?.date,
      arrivalTime: arrivalFlight?.time,
      arrivalBoardingTime: arrivalFlight?.boarding_time,
      arrivalGate: arrivalFlight?.gate,
      arrivalAirportLocation: arrivalFlight?.airport_location,
      arrivalSeat: arrivalFlight?.seat,
      
      
      departureFrom: departureFlight?.from_location,
      departureTo: departureFlight?.to_location,
      departureCarrier: departureFlight?.carrier,
      departureFlightNumber: departureFlight?.flight_number,
      departureDate: departureFlight?.date,
      departureTime: departureFlight?.time,
      departureBoardingTime: departureFlight?.boarding_time,
      departureGate: departureFlight?.gate,
      departureAirportLocation: departureFlight?.airport_location,
      departureSeat: departureFlight?.seat,
    },
    validationSchema: guestSchema,
    onSubmit,
    enableReinitialize: true,
  })

  const editGuest = (payload) => {
    
    return api.patch(`/guests/${guestID}`, payload);
  };

  
  const editGuestMutation = useMutation(editGuest, {
    onSuccess: (res) => {
      refetch()
      handleResponse('success', res)
    },
    onError: (res) => {      
      handleResponse('error', res)   
    }
  })

  const [modalStyles, setModalStyles] = useState({
    zIndex: '1',
  });


  return (
    <Modal isOpen={isOpen} toggle={toggle} style={modalStyles} className='modal-xl'>
      <ModalHeader toggle={toggle}>
        <h4 className='text-primary mb-0'>Guest Details</h4>
      </ModalHeader>
      <form onSubmit={handleSubmit}>
      <ModalBody>
          <h4 className='text-primary mb-0 mt-3'>Guest Information</h4>
          <div className='row'>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Title*</Label>
              <Input
                value={values.title}
                onChange={handleChange}
                onBlur={handleBlur}
                type="select"
                className={errors.title && touched.title ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="titleInput"
                name="title"
              >
                <option value="">Choose </option>
                <option value="Mr.">Mr. </option>
                <option value="Mrs.">Mrs. </option>
                <option value="Ms.">Ms. </option>
                <option value="Dr.">Dr. </option>
              </Input>
              {
                errors.title && touched.title && <div className="invalid-feedback">{errors.title}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">First Name*</Label>
              <Input
                value={values.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.firstName && touched.firstName ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="firstNameInput"
                placeholder="Enter First Name"
                name="firstName"
              />
              {
                errors.firstName && touched.firstName && <div className="invalid-feedback">{errors.firstName}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Last Name*</Label>
              <Input
                value={values.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.lastName && touched.lastName ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="lastNameInput"
                placeholder="Enter Last Name"
                name="lastName"
              />
              {
                errors.lastName && touched.lastName && <div className="invalid-feedback">{errors.lastName}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Phone No.*</Label>
              <Input
                value={values.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.phone && touched.phone ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="phoneInput"
                placeholder="Enter Phone No."
                name="phone"
              />
              {
                errors.phone && touched.phone && <div className="invalid-feedback">{errors.phone}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Room No.</Label>
              <Input
                value={values.room_number}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className="form-control form-control-icon green-border col-6"
                id="room_numberInput"
                placeholder="Enter Room No."
                name="room_number"
              />
            </div>

          </div>


          {/* Flight details hidden for now
          <h4 className='mt-4 mb-0 text-primary'>Departure Flight</h4>
          <div className='row'>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">From*</Label>
              <Input
                value={values.departureFrom}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureFrom && touched.departureFrom ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="fromInput"
                placeholder="Where is the flight going from?"
                name="departureFrom"
              />
              {
                errors.departureFrom && touched.departureFrom && <div className="invalid-feedback">{errors.departureFrom}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">To*</Label>
              <Input
                value={values.departureTo}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureTo && touched.departureTo ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureToInput"
                placeholder="Where is the flight going to?"
                name="departureTo"
              />
              {
                errors.departureTo && touched.departureTo && <div className="invalid-feedback">{errors.departureTo}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Carrier</Label>
              <Input
                value={values.departureCarrier}
                onChange={handleChange}
                onBlur={handleBlur}
                type="select"
                className={errors.departureCarrier && touched.departureCarrier ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureCarrierInput"
                name="departureCarrier"
              >
                <option value="">Choose</option>
                <option value="Saudia">Saudia</option>
                <option value="Emirates">Emirates</option>
                <option value="British Airways">British Airways</option>
                <option value="Qatar Airways">Qatar Airways</option>
                <option value="Etihad Airways">Etihad Airways</option>
              </Input>
              {
                errors.departureCarrier && touched.departureCarrier && <div className="invalid-feedback">{errors.departureCarrier}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Flight No.*</Label>
              <Input
                value={values.departureFlightNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureFlightNumber && touched.departureFlightNumber ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureFlightNumberInput"
                placeholder="Enter flight number"
                name="departureFlightNumber"
              />
              {
                errors.departureFlightNumber && touched.departureFlightNumber && <div className="invalid-feedback">{errors.departureFlightNumber}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Seat No.</Label>
              <Input
                value={values.departureSeat}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureSeat && touched.departureSeat ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalSeatInput"
                placeholder="Enter Seat No."
                name="departureSeat"
              />
              {
                errors.departureSeat && touched.departureSeat && <div className="invalid-feedback">{errors.departureSeat}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Date*</Label>
              <Input
                value={values.departureDate}
                onChange={handleChange}
                onBlur={handleBlur}
                type="date"
                className={errors.departureDate && touched.departureDate ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureDateInput"
                name="departureDate"
              />
              {
                errors.departureDate && touched.departureDate && <div className="invalid-feedback">{errors.departureDate}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Departure Time*</Label>
              <Input
                value={values.departureTime}
                onChange={handleChange}
                onBlur={handleBlur}
                type="time"
                className={errors.departureTime && touched.departureTime ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureTimeInput"

                name="departureTime"
              />
              {
                errors.departureTime && touched.departureTime && <div className="invalid-feedback">{errors.departureTime}</div>
              }
            </div>


            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Boarding Time</Label>
              <Input
                value={values.departureBoardingTime}
                onChange={handleChange}
                onBlur={handleBlur}
                type="time"
                className={errors.departureBoardingTime && touched.departureBoardingTime ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureBoardingTimeInput"
                placeholder="Enter departureBoardingTime"
                name="departureBoardingTime"
              />
              {
                errors.departureBoardingTime && touched.departureBoardingTime && <div className="invalid-feedback">{errors.departureBoardingTime}</div>
              }
            </div>


            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Gate</Label>
              <Input
                value={values.departureGate}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureGate && touched.departureGate ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureGateInput"
                placeholder="Enter departureGate"
                name="departureGate"
              />
              {
                errors.departureGate && touched.departureGate && <div className="invalid-feedback">{errors.departureGate}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Airport Location</Label>
              <Input
                value={values.departureAirportLocation}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.departureAirportLocation && touched.departureAirportLocation ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="departureAirportLocationInput"
                placeholder="Enter Airport Location"
                name="departureAirportLocation"
              />
              {
                errors.departureAirportLocation && touched.departureAirportLocation && <div className="invalid-feedback">{errors.departureAirportLocation}</div>
              }
            </div>
          </div>

          <div className='mt-4 mb-0 d-flex align-items-center justify-content-start'>
          <h4 className='mb-0 text-primary'>Stop <span style={{fontSize: '12px'}}>(Only add if there is a stop in guest's flight)</span></h4>
          {
            (values.arrivalFrom || 
              values.arrivalTo ||
              values.arrivalCarrier ||
              values.arrivalFlightNumber ||
              values.arrivalSeat ||
              values.arrivalDate ||
              values.arrivalTime ||
              values.arrivalBoardingTime ||
              values.arrivalGate ||
              values.arrivalAirportLocation) &&
          <BsTrashFill
          className='text-danger ms-2'
          style={{ cursor: 'pointer' }}
          onClick={() => setShowConfirmModal(true)}
          />
        }
          </div>


          <div className='row'>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">From*</Label>
              <Input
                value={values.arrivalFrom}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalFrom && touched.arrivalFrom ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="fromInput"
                placeholder="Where is the flight coming from?"
                name="arrivalFrom"
              />
              {
                errors.arrivalFrom && touched.arrivalFrom && <div className="invalid-feedback">{errors.arrivalFrom}</div>
              }
            </div>
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">To*</Label>
              <Input
                value={values.arrivalTo}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalTo && touched.arrivalTo ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalToInput"
                placeholder="Where is the flight going to?"
                name="arrivalTo"
              />
              {
                errors.arrivalTo && touched.arrivalTo && <div className="invalid-feedback">{errors.arrivalTo}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Carrier*</Label>
              <Input
                value={values.arrivalCarrier}
                onChange={handleChange}
                onBlur={handleBlur}
                type="select"
                className={errors.arrivalCarrier && touched.arrivalCarrier ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalCarrierInput"
                name="arrivalCarrier"
              >
                <option value="">Choose</option>
                <option value="Saudia">Saudia</option>
                <option value="Emirates">Emirates</option>
                <option value="British Airways">British Airways</option>
                <option value="Qatar Airways">Qatar Airways</option>
                <option value="Etihad Airways">Etihad Airways</option>
              </Input>
              {
                errors.arrivalCarrier && touched.arrivalCarrier && <div className="invalid-feedback">{errors.arrivalCarrier}</div>
              }
            </div>
            
            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Flight No.*</Label>
              <Input
                value={values.arrivalFlightNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalFlightNumber && touched.arrivalFlightNumber ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalFlightNumberInput"
                placeholder="Enter flight number"
                name="arrivalFlightNumber"
              />
              {
                errors.arrivalFlightNumber && touched.arrivalFlightNumber && <div className="invalid-feedback">{errors.arrivalFlightNumber}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Seat No.</Label>
              <Input
                value={values.arrivalSeat}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalSeat && touched.arrivalSeat ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalSeatInput"
                placeholder="Enter Seat No."
                name="arrivalSeat"
              />
              {
                errors.arrivalSeat && touched.arrivalSeat && <div className="invalid-feedback">{errors.arrivalSeat}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Date*</Label>
              <Input
                value={values.arrivalDate}
                onChange={handleChange}
                onBlur={handleBlur}
                type="date"
                className={errors.arrivalDate && touched.arrivalDate ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalDateInput"
                name="arrivalDate"
              />
              {
                errors.arrivalDate && touched.arrivalDate && <div className="invalid-feedback">{errors.arrivalDate}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Arrival Time*</Label>
              <Input
                value={values.arrivalTime}
                onChange={handleChange}
                onBlur={handleBlur}
                type="time"
                className={errors.arrivalTime && touched.arrivalTime ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalTimeInput"
                name="arrivalTime"
              />
              {
                errors.arrivalTime && touched.arrivalTime && <div className="invalid-feedback">{errors.arrivalTime}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Boarding Time</Label>
              <Input
                value={values.arrivalBoardingTime}
                onChange={handleChange}
                onBlur={handleBlur}
                type="time"
                className={errors.arrivalBoardingTime && touched.arrivalBoardingTime ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalBoardingTimeInput"
                name="arrivalBoardingTime"
              />
              {
                errors.arrivalBoardingTime && touched.arrivalBoardingTime && <div className="invalid-feedback">{errors.arrivalBoardingTime}</div>
              }
            </div>


            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Gate</Label>
              <Input
                value={values.arrivalGate}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalGate && touched.arrivalGate ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalGateInput"
                placeholder="Enter Gate"
                name="arrivalGate"
              />
              {
                errors.arrivalGate && touched.arrivalGate && <div className="invalid-feedback">{errors.arrivalGate}</div>
              }
            </div>

            <div className='col-md-6 col-12'>
              <Label className="form-label text-start mt-3 mb-1">Airport Location</Label>
              <Input
                value={values.arrivalAirportLocation}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                className={errors.arrivalAirportLocation && touched.arrivalAirportLocation ? "form-control form-control-icon is-invalid col-6" : "form-control form-control-icon green-border col-6"}
                id="arrivalAirportLocationInput"
                placeholder="Enter Airport Location"
                name="arrivalAirportLocation"
              />
              {
                errors.arrivalAirportLocation && touched.arrivalAirportLocation && <div className="invalid-feedback">{errors.arrivalAirportLocation}</div>
              }
            </div>


          </div>
          */}

      </ModalBody>
      <ModalFooter>
        {editGuestMutation.isLoading ? <p>Processing...</p>
        :
        <>
        <button onClick={toggle} type="button" className="btn admin-gray-btn">
          Close
        </button>
        <button type="submit" className="btn admin-green-btn">
          Save
        </button>
        </>
        }
      </ModalFooter>
        </form>

      <ConfirmModal
        isOpen={showConfirmModal}
        toggle={() => setShowConfirmModal(!showConfirmModal)}
        guest={guestID}
        toggleEditModal={toggle}
        refetch={refetch}
      />

    </Modal>
  );
};

export default GuestsDetailsModal;

